<div class="row">
    <div class="col col__xs--12 col__sm--6 col__md--4 col__lg--3 u-margin-bottom--20" *ngFor="let room of roomsOverview.rooms">

        <a class="card card--property" [routerLink]="['/find-a-home', room.majorArea.reference, 'home', room.propertyPublicReference, room.reference]" target="_blank">
            <div class="card__image">
                <div class="image__size image__size--4x3">
                    <img [src]="room.image.thumbnail" alt="{{room.name}} image">
                </div>
                <div class="card__image-caption">{{room.name}}</div>
            </div>

            <div class="card__content">
                <p class=" u-text-color--grey u-margin-bottom--none">
                    <ng-container *ngIf="room.minorArea != null">{{room.minorArea.label}}</ng-container>
                    <ng-container *ngIf="room.minorArea != null">,</ng-container>
                    {{room.majorArea.label}}</p>
                <h5 class="heading--4 u-margin-top--none">{{room.homeDisplayName}}</h5>
                <h6 class="heading--5 u-margin-top--10" *ngIf="room.homeDisplayName != room.headlineDescription">{{room.headlineDescription}}</h6>
                <div class="text__price">
                    <p *ngIf="showPrice">
                        <strong>{{room.rentDetails.rent | houseShareCurrency}}</strong> /
                        <ng-container *ngIf="room.rentDetails.paymentFrequency == RentPaymentFrequencies.MONTH">month</ng-container>
                        <ng-container *ngIf="room.rentDetails.paymentFrequency == RentPaymentFrequencies.WEEK">week</ng-container>
                        <ng-container *ngIf="room.rentDetails.paymentFrequency == RentPaymentFrequencies.FORTNIGHT">fortnight</ng-container>
                        <ng-container *ngIf="room.rentDetails.paymentFrequency == RentPaymentFrequencies.TERM">term</ng-container>
                        <ng-container *ngIf="room.rentDetails.paymentFrequency == RentPaymentFrequencies.QUARTER">quarter</ng-container>
                        <ng-container *ngIf="room.rentDetails.paymentFrequency == RentPaymentFrequencies.ANNUAL">year</ng-container>
                        <span *ngIf="room.rentDetails.billsInclusive == BillsInclusiveTypes.INCLUDED"> inc bills</span>
                    </p>
                    <!--<p *ngIf="room.rentDetails.billsInclusive != BillsInclusiveTypes.INCLUDED"> average bills {{room.rentDetails.averageBillCost | houseShareCurrency}}</p>-->

<!--                    <p *ngIf="room.headlineDescription != null && room.headlineDescription.length" class="text__headline">‟{{room.headlineDescription}}”</p>-->

                    <p *ngIf="room.available">
                        Available now
                    </p>



                    <p *ngIf="room.available == false && room.availableFrom != null && room.availableFrom > nowDate">
                        Available from {{room.availableFrom | houseShareDate:DateFormats.LONG}}
                    </p>
                </div>
                <div class="button__group button__group--centered">
                    <div class="button__group-item">
                        <a [routerLink]="['/find-a-home', room.majorArea.reference, 'home', room.propertyPublicReference, room.reference]" class="button button--secondary button--small button--center u-margin-top--20" target="blank">View</a>
                    </div>
                </div>

            </div>

        </a>

    </div>
</div>

<div class="row"*ngIf="roomsOverview.rooms == null || roomsOverview.rooms.length == 0">
    <div class="col col__xs--12 col__sm--12 col__md--12 col__lg--12 u-margin-bottom--20">
        <p>There are currently no rooms available</p>
    </div>
</div>

<!--<div *ngIf="roomsOverview.pages > 1">-->
<!--    <div *ngFor="let page o"-->
<!--</div>-->

<div data-iframe-height=""></div>
